export default {
      id: "ic_lieu_alu-usage",
      viewBox: "0 0 25 25",
      url: "../dist/images/" + "sprite.svg#ic_lieu_alu-usage",
      toString: function () {
        return this.url;
      }
    }